import { fetchSubContractList } from './../api/working';
import axios from 'axios';

const baseURL = process.env.REACT_APP_REST_API_URL;

// 로컬 스토리지 키 정의
const LOCAL_STORAGE_KEY_ACCESS_TOKEN = 'accessToken';
const LOCAL_STORAGE_KEY_REFRESH_TOKEN = 'refreshToken';
const LOCAL_STORAGE_KEY_EXPIRE_TIME = 'expire';

// 기본 Axios 인스턴스 설정
const axiosInstance = axios.create({
  baseURL: baseURL,
});

// 인증이 필요한 요청을 위한 Axios 인스턴스 설정
export const axiosPrivate = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

// 요청 인터셉터 설정
axiosInstance.interceptors.request.use(
  async (config) => {
    const url = config.url;
    // console.log(isAuthRequest(url));
    // JWT 인증이 필요한 요청일 경우 헤더에 토큰 추가
    if (isAuthRequest(url)) {
      // 로컬 스토리지에서 JWT를 가져옴
      let jwt = localStorage.getItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
      let expireTime = localStorage.getItem(LOCAL_STORAGE_KEY_EXPIRE_TIME);

      if (jwt && expireTime) {
        const now = Date.now() / 1000; // 현재 시간을 초 단위로 변환

        if (parseFloat(expireTime) < now) {
          // Access Token이 만료된 경우, Refresh Token으로 갱신
          await refreshAccessToken();
          // 갱신된 JWT와 expireTime을 다시 가져옴
          jwt = localStorage.getItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
          expireTime = localStorage.getItem(LOCAL_STORAGE_KEY_EXPIRE_TIME);
        }

        config.headers['Authorization'] = `Bearer ${jwt}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 응답 인터셉터 설정
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response) {
      const status = error.response.status;
      if (status === 401 || status === 403) {
        // 토큰 제거 및 로그인 페이지로 리다이렉트
        console.log('here');
        localStorage.removeItem(LOCAL_STORAGE_KEY_ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE_KEY_EXPIRE_TIME);
        window.location.replace('/login'); // useHistory 대신 window.location 사용
      }
    }

    return Promise.reject(error);
  },
);

/**
 * @brief 인증이 필요한 요청인지 확인
 * @param url 요청 URL
 * @return 인증이 필요한 요청인지 여부 boolean 값
 */
function isAuthRequest(url?: string): boolean {
  if (!url) return false;
  // console.log(
  //   /\/mypage\/driver/.test('/api/mypage/driver/entrust'),
  //   '이게 왜 False 임?',
  // );
  return (
    /\/mypage\/driver/.test(url) ||
    /\/fetch_on_dir/.test(url) ||
    /\/api\/mypage\/update\/driver\/registration/.test(url) ||
    /\/api\/mypage/.test(url) ||
    /\/mypage\/company/.test(url) ||
    /\/order\/driver/.test(url) ||
    /\/api\/obtain/.test(url) ||
    /\/api\/notice/.test(url) ||
    /\/api\/inquiry/.test(url) ||
    /\/api\/preferencecompany/.test(url) ||
    /\/api\/subcontract/.test(url) ||
    /\/api\/notification/.test(url) ||
    /\/api\/report/.test(url) ||
    /\/api\/home/.test(url) ||
    /\/order\/company/.test(url) ||
    /\/api\/admin/.test(url)
  ); // 경로 추가
}

// 리프레시 액세스 토큰 로직 추가
async function refreshAccessToken() {
  try {
    const refreshToken = localStorage.getItem(LOCAL_STORAGE_KEY_REFRESH_TOKEN);
    if (!refreshToken) {
      throw new Error('리프레시 토큰이 없습니다.');
    }

    // GET 요청 시 Authorization 헤더에 리프레시 토큰을 포함
    const response = await axiosInstance.get('/api/user/auth/reissue', {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    // 새로운 액세스 토큰과 만료 시간을 로컬 스토리지에 저장
    localStorage.setItem(
      LOCAL_STORAGE_KEY_ACCESS_TOKEN,
      response.data.accessToken,
    );
    localStorage.setItem(
      LOCAL_STORAGE_KEY_EXPIRE_TIME,
      (Date.now() / 1000 + response.data.expire).toString(),
    );
  } catch (error) {
    console.error('토큰 갱신 실패:', error);
    // 토큰 갱신 실패 시 로그인 페이지로 리다이렉트
    window.location.replace('/login');
  }
}

export default axiosInstance;
